import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader.js';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';
import type { AppRenderer } from './Renderer';

let sharedKtx2: KTX2Loader | null = null;
let sharedRenderer: AppRenderer | null = null;
let detectedRenderer: AppRenderer | null = null;

export function configureSharedGLTFLoader(renderer: AppRenderer): void {
  sharedRenderer = renderer;
  if (sharedKtx2 && detectedRenderer !== renderer) {
    sharedKtx2.detectSupport(renderer);
    detectedRenderer = renderer;
  }
}

function getKTX2Loader(): KTX2Loader {
  if (!sharedKtx2) {
    sharedKtx2 = new KTX2Loader().setTranscoderPath('/basis/');
    if (sharedRenderer) {
      sharedKtx2.detectSupport(sharedRenderer);
      detectedRenderer = sharedRenderer;
    }
  }
  return sharedKtx2;
}

export function createSharedGLTFLoader(): GLTFLoader {
  const loader = new GLTFLoader();
  loader.setMeshoptDecoder(MeshoptDecoder as unknown as Parameters<GLTFLoader['setMeshoptDecoder']>[0]);
  loader.setKTX2Loader(getKTX2Loader());
  return loader;
}
